import StyledButton from "../../NurtureProspects/ReusableComponents/Button";

import { Box } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { mixpanelCTAEvent } from "../../../Utils/mixpanelUtils";

const styles = {
  text: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    gap: "16px",
    padding: "24px 24px 0 24px",

    "& h3": {
      fontSize: "24px",
      fontWeight: "500",
      color: "rgba(0, 0, 0, 0.7)",
      margin: "0",
    },

    "& p": {
      fontSize: "16px",
      lineHeight: "22px",
      fontWeight: "400",
      color: "rgba(0, 0, 0, 0.7)",

      "& a, & a:link, & a:visited, & a:hover, & a:active": {
        color: "var(--color-primary)",
        textDecoration: "none",
        fontWeight: "600",
      },
    },
  },
  engageBtn: {
    fontSize: "16px",
    fontWeight: "600",
    border: "2px solid var(--color-primary)",
    background: "var(--color-primary)",
    padding: "16px 32px",
    boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.2)",
    height: "42px",
    transition: "all .3s",
    "&:hover": { background: "var(--color-primary-hover)", borderColor: "var(--color-primary-hover)" },
  },
};

function StartEngaging() {
  return (
    <Box sx={styles.text}>
      <img
        src="/images/brand/kynzo-wordmark-black-transparent.png"
        alt="Kynzo"
        style={{ height: "32px", width: "auto" }}
      />
      <h3>Let's Social Sell</h3>
      <p>
        Use Kynzo to engage with your customer's Linkedin™ posts.
      </p>
      <StyledButton
        sx={styles.engageBtn}
        onClick={() => {
          mixpanelCTAEvent({
            buttonName: "Open LinkedIn",
            ctaPosition: "hero",
            screenName: "extension onboarding",
          });
          window.open("https://www.linkedin.com/")
        }}
      >
        <span>Open LinkedIn</span>
        <OpenInNewIcon />
      </StyledButton>
    </Box>
  );
}

export default StartEngaging;
